import { Pipe, PipeTransform } from '@angular/core';

import { LookupItem, TypedLookupItem } from '../lookup/models';

/**
 * Return a copy of listItems without items with ids passed as arguments (passed as comma seperated)
 */
@Pipe({
  name: 'skipListItems'
})
export class SkipListItemsPipe implements PipeTransform {

  transform(listItems: LookupItem<any>[] | TypedLookupItem<any, any>[], ...args: any[]): LookupItem<any>[] | TypedLookupItem<any, any>[] {
    let result: any[] = [];

    listItems.forEach((item, index) => {
      if (!args.includes(item.itemId)) {
        result.push(item);
      }
    });

    return result;
  }
}
